import { feature as turfFeature, featureCollection as turfFeatureCollection } from '@turf/helpers'

import * as PoziUtils from 'api/utils'
import AddId from 'config/AddId'
import ApplyTransformers from 'config/ApplyTransformers'
import DetectEPSG4283 from 'config/DetectEPSG4283'
import RefreshFeatures from 'config/RefreshFeatures'
import SetMapboxStyle from 'config/SetMapboxStyle'
import { setLayerLoadDone, setLayerLoadFailed } from 'drawer/tabs/layers/actions'

export default function (geojson, projection, geojsonSource, layerConf, success) {
  if (!success) {
    console.trace('LoaderHandleGeoJSON - apply -NO SUCCESS', layerConf.titleid)
  }
  PoziUtils.gtag({
    category: 'data',
    status: 'success',
    identifier: layerConf.title,
    action: 'ajax request'
  })
  // console.log('Loader retrieved GeoJSON data for layerConf', layerConf.title)
  apply(geojson, projection, geojsonSource, layerConf, success)
}

async function apply(geojson, projection, geojsonSource, layerConf, success) {
  // console.debug('LoaderHandleGeoJSON - apply - geojson', layerConf.titleid, cloneDeep(geojson))

  geojson = geoJsonToFeatureCollection(geojson, layerConf)
  DetectEPSG4283(geojson)
  AddId(geojson, layerConf)
  ApplyTransformers(layerConf, geojson)
  await SetMapboxStyle(layerConf)
  RefreshFeatures(geojson, projection, geojsonSource, layerConf)

  window.store.dispatch(setLayerLoadDone(layerConf.titleid))

  // Inform the OL source that loading is done, triggering a 'featuresloadend' event
  if (typeof success === 'function') {
    success()
  } else {
    console.debug('LoaderHandleGeoJSON - apply - no success function provided.', layerConf.titleid)
  }

  // console.debug('LoaderHandleGeoJSON - apply - geojson - done', layerConf.titleid, cloneDeep(geojson))
}

/**
 * Converts a GeoJSON object of types other than 'FeatureCollection' (i.e. Geometry or Feature type)
 * into a FeatureCollection GeoJSON object
 *
 * @param {Object} geojson - The GeoJSON object to convert.
 * @param {Object} layerConf - The layerConf config object.
 * @return {Object} The converted Feature Collection.
 */
export const geoJsonToFeatureCollection = (geojson, layerConf) => {
  // console.debug('geoJsonToFeatureCollection - geojson', layerConf.titleid, cloneDeep(geojson))

  // If the geojson is a geometry, convert it to a feature
  if (geojson?.type === 'Geometry') {
    try {
      geojson = turfFeature(geojson)
    } catch (error) {
      console.log(
        'geoJsonToFeatureCollection - error converting geometry to feature',
        layerConf.titleid,
        error,
        geojson
      )
    }
  }

  // If the geojson is a feature, convert it to a feature collection
  if (geojson?.type === 'Feature') {
    try {
      geojson = turfFeatureCollection([geojson])
    } catch (error) {
      console.log(
        'geoJsonToFeatureCollection - error converting feature to feature collection',
        layerConf.titleid,
        error,
        geojson
      )
    }
  }

  if (geojson?.type !== 'FeatureCollection') {
    console.log(
      'geoJsonToFeatureCollection - error converting geojson to feature collection',
      layerConf.titleid,
      geojson
    )
  }

  // console.debug('geoJsonToFeatureCollection - geojson done', layerConf.titleid, cloneDeep(geojson))

  return geojson
}

export function LoaderFailed(layerConf, err, failure) {
  console.log(`LoaderFailed: failed to retrieve data for layerConf '${layerConf.titleid}' :`, err)

  PoziUtils.gtag({
    category: 'data',
    status: 'warning',
    identifier: layerConf.title,
    action: 'ajax request failed'
  })

  window.store.dispatch(setLayerLoadFailed(layerConf.titleid))

  // Inform the OL source that the loading has failed, triggering a 'featuresloaderror' event
  failure()
}
